
import Vue from 'vue'
import ScrollableContainer from './ScrollableContainer.vue'
import FlowContainer from './FlowContainer.vue'
import { PortalTarget } from 'portal-vue'
import { mapState } from 'vuex'
import { ProjectPath } from '../channel.types'

export default Vue.extend({
  props: {
    path: Object,
  },

  computed: {
    name() {
      return this.path.row.name
    },
    id() {
      return this.path.row.id
    },
    is_enabled_title_display() {
      return this.path.row.is_enabled_title_display
    },
    layout() {
      return this.path.row.layout || 'carousel'
    },
    portal_name() {
      return `portal-${this.path.row.id}`
    },
    row_tile_type() {
      return this.path.row.row_tile_type
    },
  },

  components: {
    ScrollableContainer,
    FlowContainer,
    PortalTarget,
  },
})
